import React from 'react'

const ContactUs = () => {
    return (
        <div className="staticPageWrapper p-5 text-left">
            <div
                style={{
                    marginTop: '40px',
                    padding: '20px',
                    backgroundColor: 'rgb(240, 240, 250)',
                    borderRadius: '10px',
                    textAlign: 'center',
                }}
            >
                <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: 'rgb(33, 40, 93)' }}>
                    Contact Us
                </h2>
                <p style={{ fontSize: '18px' }}>Have questions? Reach out to us!</p>
                <p style={{ fontSize: '18px' }}>
                    <b>Email:</b>{' '}
                    <a
                        href="mailto:info@carzaar.se"
                        style={{ color: 'rgb(33, 40, 93)', textDecoration: 'none' }}
                    >
                        info@carzaar.se
                    </a>
                </p>
                <p style={{ fontSize: '18px' }}>
                    <b>Phone:</b>{' '}
                    <a
                        href="tel:+46703666131"
                        style={{ color: 'rgb(33, 40, 93)', textDecoration: 'none' }}
                    >
                        +46 703 666 131
                    </a>
                </p>
            </div>
        </div>
    )
}

export default ContactUs
